import { Component, Input } from '@angular/core';
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

@Component({
  selector: 'xp-loader',
  template: `
    <div class="loader">
      <div class="loader-inner line-scale-pulse-out">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  `,
})
export class XpLoaderComponent {
  @Input() type: string;
}

((window as any).xplenty as angular.IModule).directive(
  'xpLoader',
  downgradeComponent({
    component: XpLoaderComponent,
  }),
);
